import { render, staticRenderFns } from "./area_promote_user_list.vue?vue&type=template&id=2d08d67d&scoped=true"
import script from "./area_promote_user_list.vue?vue&type=script&lang=js"
export * from "./area_promote_user_list.vue?vue&type=script&lang=js"
import style0 from "./area_promote_user_list.vue?vue&type=style&index=0&id=2d08d67d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08d67d",
  null
  
)

export default component.exports